import { useState, useCallback } from "react";

export const useHistory = (initialState) => {
  const [history, setHistory] = useState([initialState]);
  const [index, setIndex] = useState(0);

  const addToHistory = useCallback(
    (newState) => {
      setHistory((prev) => [...prev.slice(0, index + 1), newState]);
      setIndex((i) => i + 1);
    },
    [index]
  );

  const undo = useCallback(() => {
    if (index > 0) setIndex((i) => i - 1);
  }, [index]);

  const redo = useCallback(() => {
    if (index < history.length - 1) setIndex((i) => i + 1);
  }, [index, history.length]);

  const resetHistory = useCallback(() => {
    setHistory([initialState]);
    setIndex(0);
  }, [initialState]);

  return { history, index, addToHistory, undo, redo, resetHistory };
};
